export default `/* Ids Layout Grid Cell */
:host {
  line-height: normal;
}

:host(.editable),
.editable {
  position: relative;
  border: 1px solid var(--ids-color-palette-blue-20);
}

::slotted(.close-btn),
.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
}

/* Auto-fit grid with siblings layout */
:host(.ids-layout-grid-auto-fit-container) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 100%;
  gap: 8px;
}
:host(.ids-layout-grid-auto-fit-container) ::slotted(ids-data-grid[auto-fit]) {
  flex: 1 1 auto;
  min-height: 200px;
  width: 100%;
}
:host(.ids-layout-grid-auto-fit-container) ::slotted(:not(ids-data-grid)) {
  flex: 0 0 auto;
}
:host(.ids-layout-grid-auto-fit-container) ::slotted(ids-button) {
  align-self: baseline;
}

/* When a cell contains an auto-fit data grid (no siblings),
   constrain the cell so height: 100% resolves against the grid track */
:host(.ids-layout-grid-auto-fit-container.ids-layout-grid-no-siblings) {
  block-size: 100%;
  min-block-size: 0;
  min-inline-size: 0;
  overflow: visible;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtbGF5b3V0LWdyaWQiLCJzb3VyY2VzIjpbImlkcy1sYXlvdXQtZ3JpZC1jZWxsLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQTtFQUNFOzs7QUFHRjtBQUFBO0VBRUU7RUFDQTs7O0FBR0Y7QUFBQTtFQUVFO0VBQ0E7RUFDQTs7O0FBR0Y7QUFDQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFOzs7QUFJSjtBQUFBO0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi8qIElkcyBMYXlvdXQgR3JpZCBDZWxsICovXG46aG9zdCB7XG4gIGxpbmUtaGVpZ2h0OiBub3JtYWw7XG59XG5cbjpob3N0KC5lZGl0YWJsZSksXG4uZWRpdGFibGUge1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGJvcmRlcjogMXB4IHNvbGlkIHZhcigtLWlkcy1jb2xvci1wYWxldHRlLWJsdWUtMjApO1xufVxuXG46OnNsb3R0ZWQoLmNsb3NlLWJ0biksXG4uY2xvc2UtYnRuIHtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IC0xMHB4O1xuICByaWdodDogLTEwcHg7XG59XG5cbi8qIEF1dG8tZml0IGdyaWQgd2l0aCBzaWJsaW5ncyBsYXlvdXQgKi9cbjpob3N0KC5pZHMtbGF5b3V0LWdyaWQtYXV0by1maXQtY29udGFpbmVyKSB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGFsaWduLWl0ZW1zOiBzdHJldGNoO1xuICBoZWlnaHQ6IDEwMCU7XG4gIGdhcDogOHB4O1xuXG4gIDo6c2xvdHRlZChpZHMtZGF0YS1ncmlkW2F1dG8tZml0XSkge1xuICAgIGZsZXg6IDEgMSBhdXRvO1xuICAgIG1pbi1oZWlnaHQ6IDIwMHB4O1xuICAgIHdpZHRoOiAxMDAlO1xuICB9XG5cbiAgOjpzbG90dGVkKDpub3QoaWRzLWRhdGEtZ3JpZCkpIHtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgfVxuXG4gIDo6c2xvdHRlZChpZHMtYnV0dG9uKSB7XG4gICAgYWxpZ24tc2VsZjogYmFzZWxpbmU7XG4gIH1cbn1cblxuLyogV2hlbiBhIGNlbGwgY29udGFpbnMgYW4gYXV0by1maXQgZGF0YSBncmlkIChubyBzaWJsaW5ncyksXG4gICBjb25zdHJhaW4gdGhlIGNlbGwgc28gaGVpZ2h0OiAxMDAlIHJlc29sdmVzIGFnYWluc3QgdGhlIGdyaWQgdHJhY2sgKi9cbjpob3N0KC5pZHMtbGF5b3V0LWdyaWQtYXV0by1maXQtY29udGFpbmVyLmlkcy1sYXlvdXQtZ3JpZC1uby1zaWJsaW5ncykge1xuICBibG9jay1zaXplOiAxMDAlO1xuICBtaW4tYmxvY2stc2l6ZTogMDtcbiAgbWluLWlubGluZS1zaXplOiAwO1xuICBvdmVyZmxvdzogdmlzaWJsZTtcbn1cbiJdfQ== */`;
